export default __webpack_public_path__ + "static/media/upload.b5ce174e.svg";